import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {NewsWidgetController} from "../news-widget.controller";

export class NewsWidgetProps extends BaseModuleProps {
  controller: NewsWidgetController;
  numberOfGames: Number;
  className: String;
  sportTypeId: Array<Number>;
  competitionsIds: Array<Number>;
  competitorsIds: Array<Number>;
  gamesIds: Array<Number>;
  athletesIds: Array<Number>;
  isPreview: Boolean;
}
